export default {
    modal_move: {
        status: 'Mover Status - {{title}}',
        ticket: 'Mover Chamado - {{title}}',
        all_tickets: 'Mover Todos os Chamados com Status - {{title}}'
    },
    error: {
        move_tickets: 'Não foi possível mover os seguintes chamados',
        archive_tickets: 'Não foi possível arquivar os seguintes chamados',
    },
    alert: {
        archive_all_tickets_title: 'Você deseja arquivar todos os chamados com status {{status}}?',
        archive_all_tickets_text: 'Após arquivar os chamados não será mais possível atualizá-los.',
    },
}
